import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import css from 'react-css-modules';
import {default as styles} from './Tooltip.scss';

export const TOOLTIP_TYPE_BLOCK = 'TOOLTIP_TYPE_BLOCK';
export const TOOLTIP_TYPE_INLINE = 'TOOLTIP_TYPE_INLINE';
export const TOOLTIP_POSITION_TOP = 'top';
export const TOOLTIP_POSITION_RIGHT = 'right';

const Tooltip = createReactClass({
  propTypes: {
    content: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.element,
    ]).isRequired,
    details: PropTypes.string,
    icon: PropTypes.string,
    noIcon: PropTypes.bool,
    position: PropTypes.oneOf([TOOLTIP_POSITION_TOP, TOOLTIP_POSITION_RIGHT]),
    type: PropTypes.oneOf([TOOLTIP_TYPE_BLOCK, TOOLTIP_TYPE_INLINE]),
    className: PropTypes.string,
    forceVisibility: PropTypes.bool,
  },

  getDefaultProps() {
    return {
      details: null,
      position: TOOLTIP_POSITION_TOP,
      type: TOOLTIP_TYPE_BLOCK,
      icon: 'ficon-plus-circle',
      noIcon: false,
      className: '',
      forceVisibility: true,
    };
  },

  renderTooltip() {
    const {content, icon, noIcon, position, className, forceVisibility} = this.props;
    const mergedClassName = classnames(
      'tooltip',
      'fade',
      'in',
      'text-base',
      className,
      `tooltip-${position}`,
    );
    const contentClassName = classnames(
      'tooltip-inner',
      'text-center'
    );
    const iconClassName = classnames(
      'ficon',
      icon,
      'm-xs-r-sm'
    );
    const iconElement = (noIcon) ? null : <i className={iconClassName} />;
    const {details} = this.props;
    const detailsElement = (details) ? <div className="text-inverse-muted text-sm" dangerouslySetInnerHTML={{__html: details}} /> : null;
    const style = (forceVisibility) ? {display: 'block'} : {};
    const contentElement = (typeof content === 'string') ? <span dangerouslySetInnerHTML={{__html: content}} /> : content;

    return (
      <div styleName={`tooltip-${position}`} style={style} className={mergedClassName} role="tooltip">
        <div className="tooltip-arrow"></div>
        <h3 className="tooltip-title" style={{display: 'none'}}></h3>
        <div styleName="content" className={contentClassName}>
          {iconElement}{contentElement}
          {detailsElement}
        </div>
      </div>
    );
  },

  render() {
    let element = null;

    if (this.props.type === TOOLTIP_TYPE_BLOCK) {
      element = this.renderTooltip();
    } else {
      element = (
        <span styleName="inline">
          &nbsp;{this.renderTooltip()}
        </span>
      );
    }

    return element;
  },
});

export default css(Tooltip, styles);



// WEBPACK FOOTER //
// ./app/javascript/components/Tooltip.js